// DO NOT EDIT -- generated from fs/services/dx-objects/alertconfigs.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as metrics from '../../api/metrics';
import * as proactiveinsights from '../../api/proactiveinsights';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace AlertConfigsPublic {

  export const GetAlertsDetailViewEndpoint = "/grpc/dx_objects.AlertConfigsPublic/GetAlertsDetailView";
  /** BFF (Backend For Frontend) service to return the data required for viewing the main alert screen */
  export function GetAlertsDetailView(sender: (req: GetAlertsDetailViewRequest, endpoint: string) => Promise<GetAlertsDetailViewResponse>, req: GetAlertsDetailViewRequest): { promise: () => Promise<GetAlertsDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAlertsDetailViewEndpoint),
      endpoint: GetAlertsDetailViewEndpoint
    };
  }

  export const GetCreateAlertViewEndpoint = "/grpc/dx_objects.AlertConfigsPublic/GetCreateAlertView";
  /** BFF (Backend For Frontend) service to return the data required for create/editing an alert */
  export function GetCreateAlertView(sender: (req: GetCreateAlertViewRequest, endpoint: string) => Promise<GetCreateAlertViewResponse>, req: GetCreateAlertViewRequest): { promise: () => Promise<GetCreateAlertViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCreateAlertViewEndpoint),
      endpoint: GetCreateAlertViewEndpoint
    };
  }

  export const CreateAlertNotificationConfigEndpoint = "/grpc/dx_objects.AlertConfigsPublic/CreateAlertNotificationConfig";
  /** BFF (Backend For Frontend) service to create an alert notification. It wraps SetAlertConfig and CreateNotificationConfig */
  export function CreateAlertNotificationConfig(sender: (req: CreateAlertNotificationConfigRequest, endpoint: string) => Promise<CreateAlertNotificationConfigResponse>, req: CreateAlertNotificationConfigRequest): { promise: () => Promise<CreateAlertNotificationConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateAlertNotificationConfigEndpoint),
      endpoint: CreateAlertNotificationConfigEndpoint
    };
  }

  export const UpdateAlertNotificationConfigEndpoint = "/grpc/dx_objects.AlertConfigsPublic/UpdateAlertNotificationConfig";
  /** BFF (Backend For Frontend) service to update an alert notification. It wraps SetAlertConfig and UpdateNotificationConfig */
  export function UpdateAlertNotificationConfig(sender: (req: UpdateAlertNotificationConfigRequest, endpoint: string) => Promise<{}>, req: UpdateAlertNotificationConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateAlertNotificationConfigEndpoint),
      endpoint: UpdateAlertNotificationConfigEndpoint
    };
  }

  export const SubscribeAlertNotificationConfigEndpoint = "/grpc/dx_objects.AlertConfigsPublic/SubscribeAlertNotificationConfig";
  export function SubscribeAlertNotificationConfig(sender: (req: SubscribeAlertNotificationConfigRequest, endpoint: string) => Promise<{}>, req: SubscribeAlertNotificationConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SubscribeAlertNotificationConfigEndpoint),
      endpoint: SubscribeAlertNotificationConfigEndpoint
    };
  }

  export const GetAlertsListViewEndpoint = "/grpc/dx_objects.AlertConfigsPublic/GetAlertsListView";
  /** BFF (Backend For Frontend) service to return the data required for viewing the alerts list view */
  export function GetAlertsListView(sender: (req: GetAlertsListViewRequest, endpoint: string) => Promise<GetAlertsListViewResponse>, req: GetAlertsListViewRequest): { promise: () => Promise<GetAlertsListViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAlertsListViewEndpoint),
      endpoint: GetAlertsListViewEndpoint
    };
  }

  export const ArchiveAlertConfigEndpoint = "/grpc/dx_objects.AlertConfigsPublic/ArchiveAlertConfig";
  /** Archives/unarchives an AlertConfig */
  export function ArchiveAlertConfig(sender: (req: ArchiveAlertConfigRequest, endpoint: string) => Promise<ArchiveAlertConfigResponse>, req: ArchiveAlertConfigRequest): { promise: () => Promise<ArchiveAlertConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveAlertConfigEndpoint),
      endpoint: ArchiveAlertConfigEndpoint
    };
  }

  export const ArchiveAlertConfigsForDxObjectEndpoint = "/grpc/dx_objects.AlertConfigsPublic/ArchiveAlertConfigsForDxObject";
  /** Bulk Archive alerts per a given Dx Object */
  export function ArchiveAlertConfigsForDxObject(sender: (req: ArchiveAlertConfigsForDxObjectRequest, endpoint: string) => Promise<ArchiveAlertConfigsForDxObjectResponse>, req: ArchiveAlertConfigsForDxObjectRequest): { promise: () => Promise<ArchiveAlertConfigsForDxObjectResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveAlertConfigsForDxObjectEndpoint),
      endpoint: ArchiveAlertConfigsForDxObjectEndpoint
    };
  }

  export const UnarchiveAlertConfigsForDxObjectEndpoint = "/grpc/dx_objects.AlertConfigsPublic/UnarchiveAlertConfigsForDxObject";
  /** Bulk Unarchive alerts per a given Dx Object */
  export function UnarchiveAlertConfigsForDxObject(sender: (req: UnarchiveAlertConfigsForDxObjectRequest, endpoint: string) => Promise<UnarchiveAlertConfigsForDxObjectResponse>, req: UnarchiveAlertConfigsForDxObjectRequest): { promise: () => Promise<UnarchiveAlertConfigsForDxObjectResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveAlertConfigsForDxObjectEndpoint),
      endpoint: UnarchiveAlertConfigsForDxObjectEndpoint
    };
  }

  export const UpdateAlertsForMetricEndpoint = "/grpc/dx_objects.AlertConfigsPublic/UpdateAlertsForMetric";
  /** updates & validates alert after metric is updated */
  export function UpdateAlertsForMetric(sender: (req: UpdateAlertsForMetricRequest, endpoint: string) => Promise<{}>, req: UpdateAlertsForMetricRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateAlertsForMetricEndpoint),
      endpoint: UpdateAlertsForMetricEndpoint
    };
  }

  export const DuplicateAlertEndpoint = "/grpc/dx_objects.AlertConfigsPublic/DuplicateAlert";
  export function DuplicateAlert(sender: (req: DuplicateAlertRequest, endpoint: string) => Promise<DuplicateAlertResponse>, req: DuplicateAlertRequest): { promise: () => Promise<DuplicateAlertResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateAlertEndpoint),
      endpoint: DuplicateAlertEndpoint
    };
  }
}

export interface GetCreateAlertViewRequest {
  /** required */
  orgId: string;
  /** required - the metric to alert on */
  metricId: string;
  /** optional - can be used for edit */
  alertConfigId: string;
  /** recommended - the timezone for the charting data */
  timezone: string;
}

/** Used for the graph legend to display segment name and link */
export interface SegmentLegend {
  id: string;
  name: string;
}

/** Legend items for metric alert charts */
export interface LegendItem {
  segmentLegend?: SegmentLegend | null;
}

/** Legend items for metric alert charts */
export namespace LegendItem {
  export enum legend {
    segmentLegend = 2
  }

  export function legend_oneof(m: LegendItem): { opt: legend.segmentLegend, val: SegmentLegend } | null {
    if (m.segmentLegend != null) { return { opt: legend.segmentLegend, val: m.segmentLegend } }
    return null;
  }
}

export interface GetCreateAlertViewResponse {
  /** required for the metric tooltip */
  metricRecord: search_settings.MetricRecord | null;
  /** Used for the graph legend to display segment name and link */
  legendItems: LegendItem[];
  /** response from computeMetric, where each dataTable is a line on the graph */
  dataTables: metrics.DataTable[];
  /** response from computeMetric, for all previous data points */
  previousDataTables: metrics.DataTable[];
  /** will be included if alert id is passed in. Includes all the information for the alert form */
  alertNotificationConfig: AlertNotificationConfig | null;
  /** includes all non-guest users in the org, all users which may be subscribed to this alert */
  allUsers: User[];
}

/** all the data the UI needs to handle the create/edit alert screens */
export interface AlertNotificationConfig {
  /** can be passed to setAlertConfig */
  alertConfig: proactiveinsights.AlertConfig | null;
  /** Matches the creator specified in the alert config record metadata */
  alertConfigCreator: string;
  /** matches the UI options and will be mapped to pinguin.BotRecipients */
  destinationIds: string[];
  /** UserAlertPreferences holds all users subscribed to this alert in some form, either via in-app or email notifications */
  userAlertPreferences: UserAlertPreference[];
}

export interface User {
  email: string;
  firstName: string;
  lastName: string;
}

export interface UserAlertPreference {
  user: User | null;
  subscribedInApp: boolean;
  subscribedEmail: boolean;
}

export interface CreateAlertNotificationConfigRequest {
  orgId: string;
  /** all the data the UI needs to handle the create/edit alert screens */
  alertNotificationConfig: AlertNotificationConfig | null;
}

/**
 * This error details proto is attached to a CreateAlertNotificationConfig() error in the event that we have a partial
 * failure. In this case, the AlertConfig was created but the NotificationConfig failed to be created. The frontend
 * needs to know what Alert Config details page to redirect the user to in order to retry.
 */
export interface CreateAlertNotificationConfigErrorDetails {
  alertConfigId: string;
}

export enum ArchiveAlertConfigErrorReasons {
  INVALID = 0,
  DX_OBJECT_ARCHIVED = 1,
  ALERT_INCOMPATIBLE_WITH_OBJECT = 2
}

/**
 * This error details proto is attached to a single or bulk Archive action error in the
 * event that we have a failure that we want to uniquely call out to the user. For example:
 * 1. The user attempted to unarchive an alert but the DxObject it is attached to is archived (must unarchive the object first).
 * 2. The user attempted to unarchive an alert but the DxObject it is attached to is no longer compatible (must edit the object first).
 */
export interface ArchiveAlertConfigErrorDetails {
  /** The reason to highlight to the user why the request failed. */
  reason: ArchiveAlertConfigErrorReasons;
  /** The object that the alert is attached to. Returned to quickly redirect the user to this object if needed. */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
  /** The Alert Config that caused the problem. Optionally included in the event that knowing the problematic alert is helpful. */
  alertConfig: proactiveinsights.AlertConfig | null;
}

export interface CreateAlertNotificationConfigResponse {
  alertConfigId: string;
}

export interface UpdateAlertNotificationConfigRequest {
  /** required */
  orgId: string;
  /**
   * TODO(kyle): this endpoint used to have separate fields for AlertConfigId and AlertConfig.Id, and the implementation
   * always uses this AlertConfigId field in favor of the other one. It used to be that providing an AlertConfig in the
   * request was optional, in cases where the AlertConfig was unchanged, but providing AlertConfigId was always necessary
   * to fetch the notification config from pinguin. Now, AlertConfig is a required field, and it'd simplify the API to
   * only use AlertConfig.Id and remove this AlertConfigId field. But FSTA currently only sets this AlertConfigId and
   * leaves AlertConfig.Id unset. We could simplify this API as well as some code checks my moving to using AlertConfig.Id
   * and removing this field.
   * required
   */
  alertConfigId: string;
  /**
   * required even if the alert config is unchanged, some fields are used for sending notifications to users when they
   * are subscribed / unsubscribed from a metric alert
   */
  alertConfig: proactiveinsights.AlertConfig | null;
  /** optional, should be sent if integrations are added */
  addDestinationIds: string[];
  /** optional, should be sent if integration are removed */
  removeDestinationIds: string[];
  /**
   * Optional, a list of UserAlertPreferences to be updated. Each UserAlertPreference should contain the user's full
   * subscription preference. I.e. if a user is currently subscribed to InApp notifications and wishes to subscribe to
   * email notifications, then both InApp and Email should be set to true in the request. Users supplied in this list
   * with InApp and Email set to false will be unsubscribed from the alert config.
   */
  updatedSubscriptions: UserAlertPreference[];
}

export interface SubscribeAlertNotificationConfigRequest {
  orgId: string;
  alertConfigId: string;
  updatedSubscription: UserAlertPreference | null;
}

export interface GetAlertsDetailViewRequest {
  orgId: string;
  alertId: string;
}

export interface GetAlertsDetailViewResponse {
  /** required for the metric tooltip */
  metricRecord: search_settings.MetricRecord | null;
  /** Used for the graph legend to display segment name and link */
  legendItems: LegendItem[];
  /** alert & notification information */
  alertNotificationConfig: AlertNotificationConfig | null;
  /** list of other alert ids in the metric, is used for the UI to display # of # in the header */
  alertIdsForMetric: string[];
  /** the list of times when the alert went off */
  alertTriggers: AlertTrigger[];
  /** trend lines for the graph, where each dataTable is a line on the graph */
  alertDataTables: metrics.DataTable[];
  /**
   * trend lines for the graph for a previous time period, where each dataTable is a line on the graph.
   * this will only be populated for absolute & relative change alerts.
   * the data table at index i is the previous line for alert_data_tables[i]
   */
  alertPreviousDataTables: metrics.DataTable[];
  /** created by user */
  createdBy: string;
  /** the starting time for the metric */
  graphStart: protobuf.timestamp | null;
  /** the time the alert config was created */
  alertCreated: protobuf.timestamp | null;
  /** if the alert config is archived */
  archived: boolean;
  /** the access that the requesting user is allowed on this alert config, i.e. is the requesting user allowed to update or delete this alert */
  accessControl: accesscontrol.AccessResponse | null;
}

/** an object that contains the data required for alert trigger table on the right hand side of the page */
export interface AlertTrigger {
  triggerId: string;
  alertTimes: AlertTimes | null;
  /** if a metric or alert changes, we won't have data for it in the graph. We still want to display that the user was alerted, but the graph data won't exist. */
  isHistorical: boolean;
  triggerValue: number;
}

export interface AlertTrendLine {
  /** a set of data points that make up a line. Similar to metric.DataTable */
  alertDataPoints: AlertDataPoint[];
}

export interface AlertDataPoint {
  /** a single data point on the graph */
  dataRow: metrics.DataRow | null;
  /** will be an empty string, unless the data point was part of a triggered alert, which case it will contain the trigger id (also the alert insight id) */
  triggerId: string;
}

export interface GetAlertsListViewRequest {
  orgId: string;
  /** optional. If provided SupportedDxObjectType is required. Version is ignored */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
  /** when true, only returns archived alerts. when false, only returns un-archived alerts */
  archived: boolean;
}

export interface GetAlertsListViewResponse {
  rows: AlertListRow[];
  /** If the combined total of metric & segment alerts is greater than the orgs limit (default 50) */
  atAlertLimit: boolean;
  orgLimit: protobuf.int64;
  alertCount: protobuf.int64;
}

export interface AlertListRow {
  alertId: string;
  alertName: string;
  lastAlertTime: AlertTimes | null;
  /** the user who created the alert. email is guaranteed to be present, but first and last name may not be */
  createdBy: User | null;
  destinationIds: string[];
  metricId: string;
  metricName: string;
  frequency: visualizationsettings.TrendFrequency;
  timeZone: string;
  accessControl: accesscontrol.AccessResponse | null;
  subscribedUsers: UserAlertPreference[];
}

export interface AlertTimes {
  start: protobuf.timestamp | null;
  end: protobuf.timestamp | null;
}

export interface ArchiveAlertConfigRequest {
  orgId: string;
  alertConfigId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveAlertConfigResponse {
  alertConfigRecord: search_settings.AlertConfigRecord | null;
}

export interface ArchiveAlertConfigsForDxObjectRequest {
  orgId: string;
  /**
   * Determines what Dx Object to bulk archive/ unarchive for.
   * The object type is required. If Version is set, Id must also be set.
   * You can set an Id with an empty Version to unarchive/archive all related alerts.
   */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
}

export interface ArchiveAlertConfigsForDxObjectResponse {
  alertConfigRecords: search_settings.AlertConfigRecord[];
}

export interface UnarchiveAlertConfigsForDxObjectRequest {
  orgId: string;
  /**
   * Determines what Dx Object to bulk archive/ unarchive for.
   * The object type is required. If Version is set, Id must also be set.
   * You can set an Id with an empty Version to unarchive/archive all related alerts.
   */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
}

export interface UnarchiveAlertConfigsForDxObjectResponse {
  alertConfigRecords: search_settings.AlertConfigRecord[];
}

export interface UpdateAlertsForMetricRequest {
  orgId: string;
  dxIdVersion: proactiveinsights.DxIdVersion | null;
}

export interface DuplicateAlertRequest {
  orgId: string;
  alertConfigId: string;
}

export interface DuplicateAlertResponse {
  alertConfigId: string;
}
